const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

const FieldResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'fields/',
        apiRequestParams.defaults(),
        {
            query: {
                isArray: true,
                method: 'GET',
                params: Object.assign(
                    {
                        resolve: 'fieldoptions',
                    },
                    apiRequestParams.defaultMappers()
                ),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'Field'),
            },
        }
    );
};

module.exports = FieldResource;
